import "../chunk-XTU7I5IS.js";
import { ClerkInstanceContext, useClerkInstanceContext } from "@clerk/shared/react";
const [IsomorphicClerkContext, useIsomorphicClerkContext] = [ClerkInstanceContext, useClerkInstanceContext];
export {
  IsomorphicClerkContext,
  useIsomorphicClerkContext
};
//# sourceMappingURL=IsomorphicClerkContext.js.map